import { defineRecipe } from '@chakra-ui/react';

export const omniCloseButtonRecipe = defineRecipe({
  className: 'omni-close-button',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'full',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    _hover: {
      backgroundColor: 'gray.100',
      _dark: {
        backgroundColor: 'gray.700',
      },
    },
    _active: {
      backgroundColor: 'gray.200',
      _dark: {
        backgroundColor: 'gray.600',
      },
    },
    _focus: {
      outline: '2px solid',
      outlineColor: 'blue.500',
      outlineOffset: '2px',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },
  variants: {
    size: {
      sm: {
        width: '6',
        height: '6',
        fontSize: 'sm',
      },
      md: {
        width: '8',
        height: '8',
        fontSize: 'md',
      },
      lg: {
        width: '10',
        height: '10',
        fontSize: 'lg',
      },
    },
    variant: {
      solid: {
        backgroundColor: 'gray.100',
        _dark: {
          backgroundColor: 'gray.700',
        },
        _hover: {
          backgroundColor: 'gray.200',
          _dark: {
            backgroundColor: 'gray.600',
          },
        },
      },
      ghost: {
        backgroundColor: 'transparent',
        _hover: {
          backgroundColor: 'gray.100',
          _dark: {
            backgroundColor: 'gray.700',
          },
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'ghost',
  },
});
